import { useColorMode } from '@chakra-ui/react';
import { t } from 'i18next';
import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import StickyHeader from '../components/StickyHeader';
import useNotificationsQuery from '../components/api/queries/useNotificationsQuery';
import useUserProfilesListQuery from '../components/api/queries/useUserProfilesListQuery';
import NotificationTabPanel from '../components/notifications/NotificationTabPanel';
import HomeBottomNav from '../layout/HomeBottomNav';
import { usePushNotification } from '../presentation/chat/hooks/usePushNotification';

const TRADING_CATEGORY = 'trading';

export default function NotificationPage({ showBackButton = true, showBottomNav = false }) {
  const { colorMode } = useColorMode();
  const navigate = useNavigate();

  const [paginatedNotifications, setPaginatedNotifications] = useState();

  const {
    data: notificationsData,
    isFetching: isFetchingNotifications,
    fetchNextPage: fetchNextNotificationsPage,
    hasNextPage: hasNextNotificationsPage
  } = useNotificationsQuery();

  usePushNotification();

  const handlePaginatedNotifications = (paginatedData) => {
    const notifications = paginatedData.pages?.flatMap((page) =>
      page.notifications.map((notification) => notification)
    );
    setPaginatedNotifications(notifications);
  };

  const loadMoreNotifications = () => {
    if (!isFetchingNotifications && hasNextNotificationsPage) {
      fetchNextNotificationsPage();
    }
  };

  useEffect(() => {
    if (!isEmpty(notificationsData)) {
      handlePaginatedNotifications(notificationsData);
    }
  }, [notificationsData]);

  const tradingUserProfiles = useUserProfilesListQuery(TRADING_CATEGORY);
  useEffect(() => {
    if (tradingUserProfiles && tradingUserProfiles.length > 1) {
      navigate('/users/merge_profiles');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tradingUserProfiles]);

  return (
    <>
      <Helmet>
        <title>{t('tabs.notifications')}</title>
        <meta name="theme-color" content={colorMode === 'dark' ? '#0D0E12' : '#FFFFFF'} />
      </Helmet>
      <div>
        <StickyHeader
          title={t('notifications.pageTitle')}
          showTitle={true}
          alwaysShowTitle={true}
          showBackButton={showBackButton}
        />
        <div className="pb-[120px] mt-[calc(44px+env(safe-area-inset-top))] px-[16px]">
          <NotificationTabPanel
            notifications={paginatedNotifications}
            loadMore={loadMoreNotifications}
          />
        </div>
        {showBottomNav && <HomeBottomNav tabIndex={2} />}
      </div>
    </>
  );
}
